import type { Schemas } from "~/types/generated";

export enum MetricEnum {
  TotalActiveEvents = "totalActiveEvents",
  TotalActiveEventGroups = "totalActiveEventGroups",
  TotalVolume = "totalVolume",
  Volume24h = "volume24h",
  TotalOpenInterest = "totalOpenInterest",
  TotalMarkets = "totalMarkets",
  MatchedEventGroups = "matchedEventGroups",
  PlatformEventShare = "platformEventShare",
  Transactions24h = "transactions24h",
  KalshiPolymarketVolumeStats = "kalshiPolymarketVolumeStats",
}

export enum MetricsScopeEnum {
  Event = "event",
  Market = "market",
}
/**
 * Global stats/metrics are the backend contract — generated from OpenAPI, not
 * hand-written. See ../../docs/CONTRACT_TESTING.md.
 */
export type IMetrics = Schemas["GlobalStatsResponseDto"];
